import { useState } from 'react';

const faqItems = [
  {
    q: '90影院的影片真的完全免费吗？需要注册会员吗？',
    a: '是的，90影院所有影片完全免费观看，无需注册账号，无需购买会员，打开网站即可直接点播。我们通过技术优化和资源整合，为8090后影迷提供最便捷流畅的观影体验，不设置任何付费门槛。',
  },
  {
    q: '为什么90影院的播放速度这么快，真的不缓冲吗？',
    a: '我们部署了全球智能CDN加速节点，并配备多重备用线路自动切换机制。当一条线路出现拥堵时，系统会在毫秒级时间内切换到最优线路，确保1080P高清画质下依然流畅播放，最大限度减少缓冲等待。',
  },
  {
    q: '90影院的片源更新频率如何？热播剧什么时候上线？',
    a: '90影院每天保持50部以上的更新频率，与各大平台同步热播内容。院线电影下映后第一时间上线高清版，热播剧集通常在播出后24小时内更新，综艺节目当日同步，确保你不错过任何精彩。',
  },
  {
    q: '在90影院观看的影片画质怎么样？支持哪些清晰度？',
    a: '90影院全站默认1080P全高清画质，部分热门影片支持4K超清。系统会根据你的网络状况智能调整码率，在保证流畅度的同时提供最佳画质。所有影片均经过专业压制处理，画面清晰、音质出色。',
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于90影院，你可能想了解的一切
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/30 transition-colors duration-200"
              >
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-300 ${
                  openIndex === idx ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-lg text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}